import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OwnedStrategyCarouselComponent } from './owned-strategy-carousel.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SwiperModule } from 'swiper/angular';
import { OwnedStrategyCardComponent } from '../owned-strategy-card/owned-strategy-card.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from '../button/button.module';
import { RouterModule } from '@angular/router';
import { PricePipeModule } from 'src/app/pipes/price.module';
import { CurrencyDigitShortcutPipeModule } from 'src/app/pipes/currency-digit-shortcut-pipe.module';
import { InvestmentFrequencyPipeModule } from 'src/app/pipes/investment-frequency-pipe.module';
import { DaysDiffPipeModule } from 'src/app/pipes/days-diff-pipe.module';

@NgModule({
  declarations: [
    OwnedStrategyCardComponent,
    OwnedStrategyCarouselComponent,
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    SwiperModule,
    TranslateModule,
    ButtonModule,
    RouterModule,
    PricePipeModule,
    CurrencyDigitShortcutPipeModule,
    InvestmentFrequencyPipeModule,
    DaysDiffPipeModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    OwnedStrategyCarouselComponent,
  ]
})
export class OwnedStrategyCarouselModule { }
